import Page from '../../classes/Page'
import { app } from '../../utils/store'

import each from 'lodash/each'
import gsap from 'gsap'
import { clamp } from '../../utils/math'

export default class SingleProduct extends Page{
    constructor(){
        super({
            id : 'single_promo',
            element: '[data-app-page]',
            elements: {
                sheet: '#product-sheet',
                versions: '#versions' 
            },
            scroller: app.content
        })
    }

    create() {
        super.create()

        if(!app.device.mobile && this.elements.versions){ this.createVersions() }
    }

    createVersions = () => {
        const container = this.elements.sheet,
            variants = this.elements.versions.querySelectorAll('ul.list--variants')

        each(variants, (list) => {
            let totalWidth = 0
            each(list.children, (item) => { totalWidth += item.clientWidth })

            if(totalWidth > container.clientWidth){
                let offset = (container.clientWidth / 3)
                let controls = {
                    prev: document.createElement('button'),
                    next: document.createElement('button')
                }
                controls.prev.setAttribute('data-arrow','')
                controls.prev.setAttribute('data-prev','')
                controls.prev.classList = 'disabled'
                
                controls.next.setAttribute('data-arrow','')
                controls.next.setAttribute('data-next','')

                list.parentNode.append(controls.prev)
                list.parentNode.append(controls.next)

                let translateX = 0
                each(controls, (button) => {
                    button.onclick = (event) => {
                        if(event.target.hasAttribute('data-next')){
                            gsap.to(list, {
                                x: clamp(-(container.clientWidth), container.clientWidth, (translateX - offset)),
                                ease: 'linear',
                                overwrite: true,
                                onStart: () => { 
                                    translateX = clamp(-(container.clientWidth), container.clientWidth, (translateX - offset))
                                    controls.prev.classList.remove('disabled')
                                },
                                onComplete: () => {
                                    if(Math.abs(translateX) >= (totalWidth - container.clientWidth)){
                                        controls.next.classList.add('disabled')
                                    } else {
                                        controls.next.classList.remove('disabled')
                                    }
                                }
                            })
                        } else {
                            gsap.to(list, {
                                x: clamp(-(container.clientWidth), 0, (translateX + offset)),
                                ease: 'linear',
                                overwrite: true,
                                onStart: () => { 
                                    translateX = clamp(-(container.clientWidth), 0, (translateX + offset)) 
                                    controls.next.classList.remove('disabled')
                                },
                                onComplete: () => {
                                    if(Math.abs(translateX) == 0){
                                        controls.prev.classList.add('disabled')
                                    }  else {
                                        controls.prev.classList.remove('disabled')
                                    }
                                }
                            })
                        }
                    }
                })
            }
        })
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}